import React, { Component } from 'react'
import BigTagList from '../big_tag_list'
import { formatRecentBigTags, calculateTeamTags } from '../../common/components/layout/tag_sidebar'
import * as config from '../../config'
import { calcContainerHeight } from '../../util/scroll_display_utils'
import TeamSidebar from './team_sidebar'
import TagAdminModal from '../modals/tag_admin'
import DropdownButton from 'react-bootstrap/lib/DropdownButton'
import MenuItem from 'react-bootstrap/lib/MenuItem'
import TagModal from '../../components/modals/tag_modal'
import GoalTagList from '../../components/goal_tag_list'
import { prepSigilMeta } from '../../common/components/team_sigil'
import { make2Places } from '../../util/time_utils'

class TagSidebar extends Component {

    constructor(props) {
        super(props)
        this.handleSearch = this.handleSearch.bind(this)
        this.onSearchClick = this.onSearchClick.bind(this)
        this.onOptionsClick = this.onOptionsClick.bind(this)
        this.onNewTagClick = this.onNewTagClick.bind(this)

        this.state = {
            showTagAdminModal: false,
            showSearch: false,
            search: "",
            menuOpen: false,
            bigTagModal: false,
            selectedTagId: null,
        }

        this.ref = null

        this.setRef = el => {
            this.ref = el
        }
    }

    componentDidMount() {
        this.setState({scrollWindowHeight: calcContainerHeight(this.ref)})
        window.addEventListener('resize', this.resizeScrollContainer)
    }

    componentDidUpdate(prevProps) {
        if(prevProps.trialEnd != this.props.trialEnd) {
            this.setState({scrollWindowHeight: calcContainerHeight(this.ref)})
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeScrollContainer)
    }

    resizeScrollContainer = () => {
        this.setState({scrollWindowHeight: calcContainerHeight(this.ref)})
    }

    onOptionsClick() {
        this.setState({ showTagAdminModal: !this.state.showTagAdminModal })
    }

    onNewTagClick(team) {
        this.createNewTag()
    }


    onSearchClick() {
        this.setState({
            showSearch: !this.state.showSearch,
            search: "",
        })
        setTimeout(() => this.searchInput.focus(), 1)
    }

    handleSearch(e) {
        this.setState({ search: e.target.value })
    }

    hideDropdown = () => this.setState({ menuOpen: false })
    showDropdown = () => this.setState({ menuOpen: true })

    reportUser = (userEmail) => {
        const { teamMembers, reportTag, profile, viewerIsTeamAdmin } = this.props
        if (!userEmail) {
            reportTag()
            return
        }
        const member = teamMembers.find( m => m.primaryEmail === userEmail )
        if ( member && (viewerIsTeamAdmin || member.id === profile.id) ) {
            reportTag(null, member)
        }
    }

    createNewTag = () => {
        this.setState({
            bigTagModal: true,
            selectedTagId: null,
        })
    }

    editTag = ({id}) => {
        this.setState({
            bigTagModal: true,
            selectedTagId: id,
        })
    }

    closeTagModal = () => {
        this.setState({
            bigTagModal: false,
            selectedTagId: null,
        })
    }

    render() {
        const { teamMembers, teamInvites, recentTags, tags, interval = "",
            newTimer, newTimeEntry, createTag, updateTag, deleteTag,
            reportTag, deleteInvite, createInvite, toggleTagReport, profile,
            viewerIsTeamAdmin, onSelect, isTeam: isSharedTeam, team = {}, teams,
            handleDisableMember, goals, span, updateMemberRole } = this.props
        const { showSearch, search, bigTagModal, selectedTagId, scrollWindowHeight } = this.state
        const recentBigTags = formatRecentBigTags(recentTags, tags, search, profile, teams)
        const canChangeInterval = !config.isProd
        const showTeamSidebar = isSharedTeam
        const { showTagAdminModal } = this.state
        const teamTags = calculateTeamTags(tags, team)
        const allowTagEdit = !isSharedTeam || viewerIsTeamAdmin
        const goalsArray = goals.sort.reduce((acc, k) => [...acc, goals.items[k]], []) || []

        const selectedTag = tags.items[selectedTagId]
        // for now, permit tag goal creation/editing only if we are
        // 1. on a shared team
        // 2. not editing a personal tag
        const notEditingPersonalTag = !selectedTag || (teams[selectedTag.teamId] && !teams[selectedTag.teamId].isPersonal)
        const showTagGoal = isSharedTeam && notEditingPersonalTag
        const goalTags = goalsArray
            .filter(
                goal => goal.teamId === team.id
                     && goal.startDate <= span.start
                     && goal.ownerId === profile.id
                     && goal.tags.length > 0
                     && !!tags.items[goal.tags[0].tagId]
            )
            .map(
                goal => ({
                    name: tags.items[goal.tags[0].tagId].name,
                    currentAmount: goal.progress ? make2Places(goal.progress.totalDuration / 60 / 60) : 0,
                    goalAmount: make2Places(goal.budgetDuration / 60 / 60),
                    color: tags.items[goal.tags[0].tagId].color,
                    period: `this ${goal.interval}`,
                    teamSigil: prepSigilMeta(teams[goal.teamId]),
                })
            )

        return (
            <div className="tag-sidebar-container">
                <div className="tag-sidebar" style={{height: scrollWindowHeight}} ref={this.setRef}>
                    {showTeamSidebar && <TeamSidebar
                        accountName={this.props.accountName}
                        trialEnd={this.props.trialEnd}
                        setPaymentModalOpen={this.props.setPaymentModalOpen}
                        team={team}
                        teamMembers={teamMembers}
                        teamInvites={teamInvites}
                        reportTag={reportTag}
                        reportUser={ this.reportUser }
                        deleteInvite={ deleteInvite }
                        handleDisableMember={handleDisableMember}
                        createInvite={ createInvite }
                        canEditMembership={ viewerIsTeamAdmin }
                        profile={profile}
                        updateMemberRole={updateMemberRole}
                    />}

                    {goalTags.length > 0 && <div className="tag-sidebar-header">
                        <h3>Tag Goals</h3>
                    </div>}

                    {goalTags.length > 0 && <GoalTagList goalTags={goalTags} />}
                    {goalTags.length > 0 && <br/>}

                    <div className="tag-sidebar-header">
                        <h3>Tag Overview</h3>

                        <div className="options">
                            <input
                                type="text"
                                ref={input => { this.searchInput = input }}
                                className="form-control"
                                placeholder="Search"
                                value={search}
                                onChange={this.handleSearch}
                                style={{ visibility: showSearch ? 'visible' : 'hidden' }}
                            />
                            <button onClick={this.onSearchClick} className="btn btn-xs btn-search btn-default ">
                                <i className="fa fa-search"></i>
                            </button>

                            <DropdownButton
                                className="btn btn-xs btn-options btn-default "
                                id="tag-overview-dropdown"
                                title={<i className="fa fa-ellipsis-h" aria-hidden="true"></i>}
                                pullRight
                                noCaret
                                bsStyle="default"
                                open={this.props.menuOpen}
                                onToggle={(e) => { }}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    this.showDropdown()
                                }
                                }>
                                <MenuItem id="manage-tags" onClick={(e) => {
                                    e.stopPropagation()
                                    this.onOptionsClick()
                                }}>
                                        Manage Tags
                                </MenuItem>
                                {allowTagEdit && <MenuItem id="new-tag" onClick={(e) => {
                                    e.stopPropagation()
                                    this.createNewTag()}}>
                                        New Tag
                                </MenuItem>}
                            </DropdownButton>

                        </div>
                    </div>

                    {canChangeInterval && <span className="tag-sidebar-interval">This <a>{interval.toLowerCase()}</a></span>}
                    {!canChangeInterval && <span className="tag-sidebar-interval">This {interval.toLowerCase()}</span>}

                    <BigTagList
                        bigTags={recentBigTags}
                        newTimeEntry={newTimeEntry}
                        createNewTag={this.createNewTag}
                        editTag={this.editTag}
                        newTimer={newTimer}
                        toggleTagReport={toggleTagReport}
                        onSelect={onSelect}
                    />

                    <TagAdminModal tags={teamTags}
                        team={team}
                        isPersonal={!isSharedTeam}
                        allowEdit={allowTagEdit}
                        showTagAdminModal={showTagAdminModal}
                        toggleTagAdminModal={this.onOptionsClick}
                        editTag={this.editTag}
                        createNewTag={this.createNewTag}
                        reportTag={reportTag}
                    />

                    <TagModal
                        {...this.props}
                        show={bigTagModal}
                        trialEnd={this.props.trialEnd}
                        team={team}
                        setPaymentModalOpen={this.props.setPaymentModalOpen}
                        closeTagModal={this.closeTagModal}
                        createTag={createTag}
                        updateTag={updateTag}
                        deleteTag={deleteTag}
                        selectedTagId={this.state.selectedTagId}
                        dashboardTeamId={team.id}
                        teams={this.state.teams}
                        profile={profile}
                        showTagGoal={showTagGoal}
                    />

                </div>
            </div>
        )
    }
}

export default TagSidebar



// WEBPACK FOOTER //
// ./src/components/layout/tag_sidebar.jsx